import { Effort, EffortDto, EffortListItem } from 'types/efforts';
import { NamedEntityMinDto } from 'types/other';
import { injectCountEndPoint, portalAPI } from './portalAPI';
import { accumulatedQueryWithFilters } from './util/endpointBuilder';

const APIEffortsSlice = portalAPI
    .enhanceEndpoints({
        addTagTypes: [
            'Efforts',
            'EffortsCount',
            'EffortListItem',
            'EffortsMin',
            'Party',
            'PortfolioParties',
            'TimeRecords',
        ],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getEffortById: builder.query<Effort, string>({
                query: (entityId) => `/v1/efforts/${entityId}`,
                providesTags: (_1, _2, arg) => [{ type: 'Efforts', id: arg }],
                keepUnusedDataFor: 0,
            }),
            getEffortsWithFilters: accumulatedQueryWithFilters<EffortListItem>(builder, '/v1/efforts', {
                providesTags: ['EffortListItem'],
                dedupeKey: (effort) => effort.id,
            }),
            getEffortsCount: injectCountEndPoint(builder, '/v1/efforts', 'EffortsCount'),
            getEffortsList: accumulatedQueryWithFilters<NamedEntityMinDto>(builder, '/v1/efforts/min', {
                providesTags: ['EffortsMin'],
            }),
            addEffort: builder.mutation<Effort, EffortDto>({
                query: ({ ...body }) => ({
                    url: `/v1/efforts`,
                    method: 'POST',
                    body,
                }),
                invalidatesTags: [
                    'Efforts',
                    'EffortListItem',
                    'EffortsMin',
                    'Party',
                    'PortfolioParties',
                    'TimeRecords',
                ],
            }),
            updateEffort: builder.mutation<Effort, EffortDto>({
                query: ({ id, ...body }) => ({
                    url: `/v1/efforts/${id}`,
                    method: 'PUT',
                    body,
                }),
                invalidatesTags: (_1, _2, arg) =>
                    arg.id
                        ? [
                              'Efforts',
                              'EffortListItem',
                              'EffortsMin',
                              'PortfolioParties',
                              'TimeRecords',
                              { type: 'Efforts', id: arg.id },
                          ]
                        : ['Efforts', 'EffortListItem', 'EffortsMin', 'PortfolioParties', 'TimeRecords'],
            }),
            deleteEffort: builder.mutation<boolean, { id: string }>({
                query: ({ id }) => ({
                    url: `/v1/efforts/${id}`,
                    method: 'DELETE',
                }),
                invalidatesTags: ['EffortListItem', 'EffortsMin', 'PortfolioParties', 'TimeRecords'],
            }),
        }),
        overrideExisting: false,
    });

export const {
    useGetEffortByIdQuery,
    useLazyGetEffortsWithFiltersQuery,
    useLazyGetEffortsCountQuery,
    useAddEffortMutation,
    useUpdateEffortMutation,
    useDeleteEffortMutation,
} = APIEffortsSlice;
